import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';

export const table = css`
  border-collapse: collapse;
  table-layout: fixed;
  margin-top: 40px;
  width: 100%;
`;

export const info = css`
  border-bottom: 1px solid ${colors.gray.light};
  display: table-row;
  vertical-align: top;

  :last-child {
    border-bottom: none;
  }
`;

export const vehicleColumn = css`
  width: 43%;
`;

export const iconsColumn = css`
  width: 42px;
`;

export const iconsColumnData = css`
  padding: 20px 20px 20px 0;

  > div {
    margin-top: 12px;
  }
`;

export const vehicleInfo = css`
  padding: 30px 20px 20px 0px;

  > span {
    display: block;
    margin-bottom: 10px;

    :last-child {
      margin-bottom: 0;
    }
  }
`;

export const calendar = css`
  padding: 30px 20px 20px 0;
  width: 100%;

  > div {
    margin-top: 4px;
  }
`;

export const odometer = css`
  padding: 10px 0 20px 0;
  width: 100%;
  margin-top: 4px;

  > input {
    margin: 10px 10px 0px;
  }
`;
